import { render, staticRenderFns } from "./NotificationsBell.vue?vue&type=template&id=e07cd4e4&scoped=true&"
import script from "./NotificationsBell.vue?vue&type=script&lang=js&"
export * from "./NotificationsBell.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsBell.vue?vue&type=style&index=0&id=e07cd4e4&scoped=true&lang=css&"
import style1 from "./NotificationsBell.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07cd4e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
